import React from 'react';
import { useLocation } from 'react-router-dom';
import { ContentTemplate, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import { candidateService } from '../../api';
import ResultsAppealSummary from '../../modules/appeal/components/@opadmin/ResultsAppealSummary';

const ResultsAppealDetails = () => {
  const { state } = useLocation();
  const { t } = useTranslation();

  // @ts-ignore
  const { data } = candidateService.appeal.opadmin.useGetResultsAppealDetails(state && state.uuid);

  return (
    <>
      <TitleHeader title={t('appeal->>ResultsAppealSummary.Results Appeal Details')} />

      <ContentTemplate type="full">
        <ResultsAppealSummary
          appealSummary={data}
          backButton={{
            label: t('appeal->>ResultsAppealSummary.Back'),
            name: 'back',
          }}
        />
      </ContentTemplate>
    </>
  );
};

export default ResultsAppealDetails;
